import React from "react";
import { FileText, Image as ImageIcon, Download } from "lucide-react";
import { formatDate } from "@/lib/utils-app";
import { API, getToken } from "@/lib/api";

function fileIcon(type) {
  if (!type) return FileText;
  if (type.startsWith("image/")) return ImageIcon;
  return FileText;
}

function formatSize(bytes) {
  if (!bytes) return "";
  if (bytes < 1024) return `${bytes} B`;
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`;
  return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
}

export default function DocumentTile({ doc }) {
  const Icon = fileIcon(doc.content_type);
  const isImg = doc.content_type?.startsWith("image/");
  const url = `${API}/crm/documents/${doc.doc_id}/download?auth=${getToken() || ""}`;

  return (
    <div
      data-testid={`document-tile-${doc.doc_id}`}
      className="group bg-white border border-zinc-200 rounded-sm overflow-hidden transition-all duration-200 hover:border-blue-400"
    >
      <div className="aspect-[4/3] bg-zinc-50 flex items-center justify-center relative">
        {isImg ? (
          <img src={url} alt={doc.filename} className="w-full h-full object-cover" />
        ) : (
          <div className="flex flex-col items-center gap-2">
            <Icon className="w-12 h-12 text-blue-700 stroke-[1.25]" />
            <span className="text-xs font-semibold uppercase tracking-wider text-zinc-500">
              {doc.filename.split(".").pop()}
            </span>
          </div>
        )}
      </div>
      <div className="p-3 border-t border-zinc-200">
        <div className="text-sm font-medium text-zinc-900 truncate" title={doc.filename}>
          {doc.filename}
        </div>
        <div className="mt-1 flex items-center justify-between text-xs text-zinc-500">
          <span>{formatDate(doc.uploaded_at)} · {formatSize(doc.size)}</span>
          <a
            href={url}
            target="_blank"
            rel="noreferrer"
            data-testid={`download-${doc.doc_id}`}
            className="p-1 hover:text-blue-700"
            title="Visa"
          >
            <Download className="w-3.5 h-3.5 stroke-[1.5]" />
          </a>
        </div>
      </div>
    </div>
  );
}
